<div class="grid" style="margin-top: -50px !important">
  <div class="md:col-6 col-12 lg:col-6" style="text-align: left"></div>
  <div class="md:col-6 col-12 lg:col-6">
    <button
      class="pull-right"
      (click)="mostrarWidgets()"
      type="button"
      pButton
      icon="fa fa-wrench"
      label="{{ 'INICIO_DASHBOARD.LBL_CONFIGURARWIDGETS' | translate }}"
    ></button>
  </div>
</div>
<div style="display: grid; grid-template-columns: repeat(3, 22%); gap: 1rem">
  <app-widget-simulador-credito
  *ngIf="verWidget('SIMULA')"
  ></app-widget-simulador-credito>
  <app-widget-perfil-crezcamos
  *ngIf="verWidget('WPECRZ')"
  ></app-widget-perfil-crezcamos>
  <app-widget-usuario-cargo
    *ngIf="verWidget('ACTUCARG')"
  ></app-widget-usuario-cargo>
  <app-widget-integraciones-shivam
    *ngIf="verWidget('ONOFFSERSHI')"
  ></app-widget-integraciones-shivam>
  <app-widget-aprobacion-solicitudes
    *ngIf="verWidget('ANUSOL')"
  ></app-widget-aprobacion-solicitudes>
  <app-fondo-garantia *ngIf="verWidget('FONGAR')"></app-fondo-garantia>
  <app-widget-solicitud-ahorro-pendiente
    *ngIf="verWidget('SOLAHO')">
  </app-widget-solicitud-ahorro-pendiente>
  <app-widget-solicitud-inversion-pendiente *ngIf="verWidget('SOLINV')"></app-widget-solicitud-inversion-pendiente>
  <app-widget-tershi
    *ngIf="verWidget('TERSHI')"
  ></app-widget-tershi>
  <app-widget-anulacion-pagare
    *ngIf="verWidget('PAGACT')">
  </app-widget-anulacion-pagare>
  <app-sincronizacion-offline
    *ngIf="verWidget('SINCOFF')">
  </app-sincronizacion-offline>
</div>
<app-widget-filtro-prospecto-perfil
  *ngIf="carInformacionTercero"
  [widActividad]="verWidget('ACTOFIPPD')"
  [widEjecutivo]="verWidget('EJECOFIC')"
  [widMeses]="verWidget('PROVSPERF')"
  [nivUsuario]="nivUsuario"
  [terCargo]="terCargo"
></app-widget-filtro-prospecto-perfil>
<p-dialog
  header="{{ 'INICIO_DASHBOARD.CONF_WIDGETS' | translate }}"
  [(visible)]="verWidgets"
  [positionTop]="10"
  modal="true"
  [style]="{'width':'500px'}"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template ngFor let-widget [ngForOf]="todWidgets" let-i="index">
    <div>
      <div *ngIf="!widget.obligatorio">
        <p-checkbox
          name="widgets"
          value="{{ widget.codigoWidget }}"
          [disabled]="widget.deshabilitar"
          [(ngModel)]="widget.visible"
          label="{{ widget.descripcion }}"
          (onChange)="actualizarUsuarioWidget(widget)"
          binary="true"
        ></p-checkbox>
      </div>
    </div>
  </ng-template>
  <div class="grid" *ngIf="!carWidgets && ( todWidgets.length === 0 || todosObligatorios )">
    <div class="col-12 text-center">
      <div
        style="
          background-color: #d9d9d9;
          border: 2px #999999 solid;
          padding: 5px 10px;
          text-align: center;
          color: black;
        "
      >
        <strong>{{
          "INICIO_DASHBOARD.MSG_NOEXISTENWIDGETS" | translate
        }}</strong>
      </div>
    </div>
  </div>
</p-dialog>

<!-- MENSAJE NOTIFIACION RESPONSABILIDAD -->
<p-dialog
  id="dlgNotificacionResponsabilidad"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  *ngIf="showModalNotificacionResponsabilidad"
  [(visible)]="showModalNotificacionResponsabilidad"
  [contentStyle]="{
    width: '600px',
    'overflow-y': 'auto',
    'max-height': '350px',
    'overflow-x': 'auto'
  }"
  [header]="'LBL_AVISO' | translate"
  [modal]="true"
>
  <div class="row grid">
    <div class="col-4">
      <img
        alt="Aviso de responsabilidad dashboard"
        src="assets/images/imagen-aviso-responsabilidad.png"
        style="height: 230px"
      />
    </div>
    <div class="col-8" style="text-align: justify">
      <div
        *ngIf="defaultMessage"
        [innerHTML]="plantilla ? plantilla : defaultMessage"
      ></div>
      <div class="grid form-footer-buttons">
        <div class="formgrid col-12">
          <button
            label="{{ 'BTN_CERRAR' | translate }}"
            type="button"
            pButton
            (click)="cerrarModalResponsabilidad()"
          ></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
